/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {useIntl} from 'react-intl'
import {SALUTATION_OPTIONS} from '../../constants'

export default function useAccountDataFields({form: {control, errors}, prefix = ''}) {
    const {formatMessage} = useIntl()

    return {
        salutation: {
            name: `${prefix}salutation`,
            label: formatMessage({
                defaultMessage: 'Salutation',
                id: 'use_address_fields.label.salutation'
            }),
            defaultValue: 'Mr',
            type: 'select',
            options: SALUTATION_OPTIONS.map((option) => ({
                value: option.value,
                label: formatMessage(option.label)
            })),
            error: errors[`${prefix}salutation`],
            control
        },
        firstName: {
            name: `${prefix}firstName`,
            label: formatMessage({
                defaultMessage: 'First name',
                id: 'mystokke.personal-information.firstName'
            }),
            type: 'text',
            defaultValue: '',
            inputProps: {
                variant: 'flushed',
                autoComplete: 'given-name'
            },
            rules: {
                required: formatMessage({
                    defaultMessage: 'This field is required.',
                    id: 'global.error.field_is_required'
                })
            },
            error: errors[`${prefix}firstName`],
            control
        },
        lastName: {
            name: `${prefix}lastName`,
            label: formatMessage({
                defaultMessage: 'Last name',
                id: 'mystokke.personal-information.lastName'
            }),
            type: 'text',
            defaultValue: '',
            inputProps: {
                variant: 'flushed',
                autoComplete: 'family-name'
            },
            rules: {
                required: formatMessage({
                    defaultMessage: 'This field is required.',
                    id: 'global.error.field_is_required'
                })
            },
            error: errors[`${prefix}lastName`],
            control
        },
        birthday: {
            name: `${prefix}birthday`,
            label: formatMessage({
                defaultMessage: 'Birthday',
                id: 'mystokke.personal-information.birthday'
            }),
            type: 'date',
            defaultValue: '',
            inputProps: {
                variant: 'flushed',
                autoComplete: 'bday'
            },
            control
        },
        phone: {
            name: `${prefix}phone`,
            label: formatMessage({
                defaultMessage: 'Phone',
                id: 'use_address_fields.label.phone'
            }),
            type: 'phone',
            defaultValue: '',
            inputProps: {
                variant: 'flushed',
                autoComplete: 'tel'
            },
            control
        }
    }
}
